import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { SCMaterial } from 'app/core/store/stock-count/stock-count.interface';
import { util } from '../../../../../../core/util/util';

@Component({
  selector: 'app-stock-count-material',
  templateUrl: './stock-count-material.component.html',
  styleUrls: ['./stock-count-material.component.scss'],
})
export class StockCountMaterialComponent {
  checked: boolean = false;
  counted: string = '';
  checkBoxdisabled: boolean = false;
  txtDisabled: boolean = false;

  @Input() columns: any;
  @Input() material: SCMaterial;
  @Input() shipTos: Definition[];
  @Input() definitions: Definitions;

  @Output() addCountedMaterial: EventEmitter<SCMaterial> = new EventEmitter();
  @Output() removeCountedMaterial: EventEmitter<SCMaterial> = new EventEmitter();
  @Output() updateCountedMaterial: EventEmitter<SCMaterial> = new EventEmitter();

  findPackingId(id: string): string {
    if (id && this.definitions) {
      const packing = this.definitions.packing.type.find(packing => packing.id === id);
      return packing && packing.name ? packing.name : '';
    } else {
      return '';
    }
  }

  checkBoxChanged() {
    if (this.checked) {
      this.txtDisabled = true;
      this.updateMaterial();
    } else {
      this.txtDisabled = false;
      this.updateMaterial();
    }
  }

  numericOnly(event): boolean {
    const patt = /^([0-9])$/;
    const result = patt.test(event.key);
    return result;
  }

  isTxtDisabled(): string | null {
    return this.txtDisabled ? '' : null;
  }

  countedAmountChanged(amount: string) {
    this.counted = amount;
    const nrCounted = util.toNumber(this.counted);
    if (nrCounted || nrCounted === 0) {
      this.checkBoxdisabled = true;
    } else {
      this.checkBoxdisabled = false;
    }
    this.updateMaterial();
  }

  updateMaterial() {
    const countedNr = util.toNumber(this.counted);
    const updatedMaterial: SCMaterial = {
      ...this.material,
      ...(countedNr && { countedAmount: countedNr }),
      notCounted: this.checked,
      isValid: !!(countedNr || countedNr === 0 || this.checked),
    };
    this.updateCountedMaterial.emit(updatedMaterial);
  }
}
